import React, { useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterSheetInterface,
  TransformInstance,
} from "@dndModels";

// import DandDCharacterUtilities from '../../../utilities/character_utilities';

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
}

// const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterAdvantageButton({
  character,
  char_interface,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [advantage, setAdvantage] = useState(char_interface.advantage);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const recalculated = () => {
    setAdvantage(char_interface.advantage);
    setReloading(true);
  }
  
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <ToggleButtonBox 
          name="Advantage"
          value={advantage > 0}
          style={{
            height: "16px",
            fontSize: "10px",
            lineHeight: "1.5",
          }}
          colors={{ backgroundColor: "green", color: "White" }}
          onToggle={() => {
            if (character.advantage > 0) {
              character.advantage = 0;
            } else {
              character.advantage = 1;
            }
            if (char_interface instanceof TransformInstance) {
              char_interface.advantage = character.advantage;
            }
            character.changed();
            char_interface.subscription_holder.recalculated();
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <ToggleButtonBox 
          name="Disadvantage"
          value={advantage < 0}
          style={{
            height: "16px",
            fontSize: "10px",
            lineHeight: "1.5",
          }}
          colors={{ backgroundColor: "red", color: "White" }}
          onToggle={() => {
            if (character.advantage < 0) {
              character.advantage = 0;
            } else {
              character.advantage = -1;
            }
            if (char_interface instanceof TransformInstance) {
              char_interface.advantage = character.advantage;
            }
            character.changed();
            char_interface.subscription_holder.recalculated();
          }}
        />
      </Grid>
    </Grid>
  );
}
